import { T_SHIRT_SIZES } from './T_SHIRT_SIZES';
export var PROGRESS_METER_SIZES = Object.freeze({
  sm: T_SHIRT_SIZES.sm,
  md: T_SHIRT_SIZES.md
});